export default "__VITE_ASSET__CYxOnGsY__"